import { isSuperAdmin } from "../../../utils/roleUtils";
import { inputs } from "../../inputs/inputConfigs";

const fields = (role, isUpdate) => ({
  groups: [
    {
      items: [
        {
          input: {
            ...inputs.firstName,
            name: "person.firstName",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.lastName,
            name: "person.lastName",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.phone,
            label: "Phone Number",
            name: "person.phoneNumber",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.fax,
            label: "Fax",
            name: "person.faxNumber",
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.fax,
            label: "Cell Number",
            name: "person.cellNumber",
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.fax,
            label: "Work Number",
            name: "person.workNumber",
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.contactRole,
            name: inputs.contactRole.name,
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.email,
            name: "person.email",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: inputs.contactStatus,
          grid: { xs: 6 },
        },
        {
          input: isSuperAdmin(role)
            ? { ...inputs.scopeId, isDisabled: isUpdate }
            : null,
          grid: { xs: 6 },
        },
      ],
    },
  ],
});

export default (role, isUpdate) => {
  return fields(role, isUpdate);
};
